/** CoStar.Api.ConsumerUserData.ListingSearchPreference.ListingSearchType */
export var ListingSearchType;
(function (ListingSearchType) {
    ListingSearchType[ListingSearchType["Luxury"] = 1] = "Luxury";
    ListingSearchType[ListingSearchType["Cheap"] = 2] = "Cheap";
    ListingSearchType[ListingSearchType["College"] = 3] = "College";
})(ListingSearchType || (ListingSearchType = {}));
/** CoStar.Api.ConsumerUserData.ListingSearchPreference.ListingSearchPreferenceType */
export var ListingSearchPreferenceType;
(function (ListingSearchPreferenceType) {
    ListingSearchPreferenceType[ListingSearchPreferenceType["NoPreference"] = 0] = "NoPreference";
    ListingSearchPreferenceType[ListingSearchPreferenceType["Include"] = 1] = "Include";
    ListingSearchPreferenceType[ListingSearchPreferenceType["Exclude"] = 2] = "Exclude";
})(ListingSearchPreferenceType || (ListingSearchPreferenceType = {}));
